import { Suspense, useEffect } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';

import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import LiveBanner from '../components/LiveBanner';
import { Loader } from '../components/Loader/Loader';
import AppPortal from '../components/portals/AppPortal';
import { useHideLoader } from '../hooks/useHideLoader';
import { LocaleProvider } from '../providers';
import { navigationService } from '../services/navigation';
import { StoreProvider } from '../stores/StoreProvider';

function LayoutContent() {
  useHideLoader();
  const navigate = useNavigate();

  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return (
    <LocaleProvider>
      <Suspense fallback={<Loader fullScreen />}>
        <ErrorBoundary>
          <LiveBanner />
          <Outlet />
        </ErrorBoundary>
      </Suspense>
      <AppPortal />
    </LocaleProvider>
  );
}

export default function Layout() {
  return (
    <StoreProvider>
      <LayoutContent />
    </StoreProvider>
  );
}
